"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStartDate = getStartDate;
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _getWeekOfMonth = _interopRequireDefault(require("date-fns/getWeekOfMonth"));

var _getDaysInMonth = _interopRequireDefault(require("date-fns/getDaysInMonth"));

var _isLastDayOfMonth = _interopRequireDefault(require("date-fns/isLastDayOfMonth"));

var _isWeekend = _interopRequireDefault(require("date-fns/isWeekend"));

var _getDay = _interopRequireDefault(require("date-fns/getDay"));

var _getDate = _interopRequireDefault(require("date-fns/getDate"));

var _getMonth = _interopRequireDefault(require("date-fns/getMonth"));

var _getYear = _interopRequireDefault(require("date-fns/getYear"));

var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));

var _date = require("../../utils/date");

var _debtinatorAtom = require("../utils/debtinator-atom");

// default : (idx, atom, values) => { id : atom.id, idx, value : atom.default}
// atom : (idx, atom, values) => atom,
// value:(idx, atom, value, values) => value,
function getStartOfDay(idx, atom) {
  return {
    id: atom.id,
    idx: idx,
    value: (0, _date.todayAtMidnightString)()
  };
}

function getStartDate(values, parentValues) {
  var startingOn = values.find(function (val) {
    return val.id === "startingOnSelector";
  });

  if (startingOn) {
    return startingOn.value;
  } else if (parentValues) {
    return getStartDate(parentValues.values, parentValues.parentValues);
  } else {
    throw "Cannot find startDate given ".concat(values, " and ").concat(parentValues);
  }
}

var processors = {
  magnitude: {
    value: function value(idx, atom, _value) {
      return Math.max(_value, 1);
    }
  },
  repeatSelector: {
    atom: function atom(idx, _atom, values, parentValues) {
      var today = (0, _date.parseDateString)(getStartDate(values, parentValues));
      var options = [{
        value: "days",
        label: "day(s)"
      }, {
        value: "business days",
        label: "business day(s)"
      }, {
        value: "weeks",
        label: "week(s)"
      }, {
        value: "weekdays",
        label: "month(s)"
      }, {
        value: "last weekdays",
        label: "month(s)"
      }, {
        value: "months",
        label: "month(s)"
      }, {
        value: "quarters",
        label: "quarter(s)"
      }, {
        value: "years",
        label: "year(s)"
      }, {
        value: "weekday years",
        label: "year(s)"
      }, {
        value: "last weekday years",
        label: "year(s)"
      }];
      var magnitude = values.find(function (v) {
        return v.id === "magnitude";
      });

      if (magnitude) {
        options = options.map(function (option) {
          var label = option.label.replace(/\(s\)/, magnitude.value === 1 ? "" : "s");
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, option), {}, {
            label: label
          });
        });
      } // const today = new Date();


      var weeksOption = options.find(function (o) {
        return o.value === "weeks";
      });
      weeksOption.label += " on ".concat(_date.weekdays[(0, _getDay.default)(today)]);
      var weekdaysOption = options.find(function (o) {
        return o.value === "weekdays";
      });
      var weekNum = (0, _getWeekOfMonth.default)(today, {
        weekStartsOn: (0, _getDay.default)((0, _startOfMonth.default)(today))
      });
      weekdaysOption.label += " on the ".concat((0, _date.addDayCardinality)(String(weekNum)), " ").concat(_date.weekdays[(0, _getDay.default)(today)]);
      var lastWeekdaysOption = options.find(function (o) {
        return o.value === "last weekdays";
      });
      var daysInMonth = (0, _getDaysInMonth.default)(today);
      lastWeekdaysOption.label += " on the ".concat((0, _date.formatWeeksFromEnd)((0, _getDate.default)(today), daysInMonth), " ").concat(_date.weekdays[(0, _getDay.default)(today)]);
      var monthsOption = options.find(function (o) {
        return o.value === "months";
      });

      if ((0, _isLastDayOfMonth.default)(today)) {
        monthsOption.label += " on the last day";
      } else {
        monthsOption.label += " on the ".concat((0, _getDate.default)(today));
        monthsOption.label = (0, _date.addDayCardinality)(monthsOption.label);
      }

      var yearOption = options.find(function (o) {
        return o.value === "years";
      });
      yearOption.label += " on ".concat(_date.months[today.getMonth()], " ").concat((0, _getDate.default)(today));
      yearOption.label = (0, _date.addDayCardinality)(yearOption.label);
      var weekdayYearsOption = options.find(function (o) {
        return o.value === "weekday years";
      });
      weekdayYearsOption.label += " on the ".concat((0, _date.addDayCardinality)(String(weekNum)), " ").concat(_date.weekdays[(0, _getDay.default)(today)], " of ").concat(_date.months[today.getMonth()]);
      var lastWeekdayYearsOption = options.find(function (o) {
        return o.value === "last weekday years";
      });
      lastWeekdayYearsOption.label += " on the ".concat((0, _date.formatWeeksFromEnd)((0, _getDate.default)(today), daysInMonth), " ").concat(_date.weekdays[(0, _getDay.default)(today)], " of ").concat(_date.months[today.getMonth()]); // remove business days, if necessary

      if ((0, _isWeekend.default)(today)) {
        var businessDayIdx = options.findIndex(function (o) {
          return o.value === "business days";
        });
        options.splice(businessDayIdx, 1);
      }

      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _atom), {}, {
        type: "select",
        options: options,
        default: "months"
      });
    }
  },
  startingOnSelector: {
    default: getStartOfDay,
    value: function value(idx, atom, _value2) {
      if (_value2 === "") {
        return (0, _date.todayAtMidnightString)();
      } else {
        return _value2;
      }
    }
  },
  onDateInput: {
    default: function _default(idx, atom) {
      return {
        id: atom.id,
        idx: idx,
        value: (0, _getDate.default)((0, _date.todayAtMidnight)())
      };
    }
  },
  onWeekSelector: {
    default: function _default(idx, atom) {
      return {
        id: atom.id,
        idx: idx,
        value: _date.weekdays[(0, _getDay.default)((0, _date.todayAtMidnight)())]
      };
    }
  },
  exceptOnDay: {
    default: function _default(idx, atom) {
      return {
        id: atom.id,
        idx: idx,
        value: _date.weekdays[(0, _getDay.default)((0, _date.todayAtMidnight)())]
      };
    }
  },
  exceptInMonth: {
    default: function _default(idx, atom) {
      return {
        id: atom.id,
        idx: idx,
        value: _date.months[(0, _getMonth.default)((0, _date.todayAtMidnight)())]
      };
    }
  },
  exceptInYear: {
    default: function _default(idx, atom) {
      return {
        id: atom.id,
        idx: idx,
        value: (0, _getYear.default)((0, _date.todayAtMidnight)())
      };
    }
  },
  untilDate: {
    default: getStartOfDay
  },
  betweenStartDate: {
    default: getStartOfDay
  },
  betweenEndDate: {
    default: getStartOfDay
  },
  exceptOnDate: {
    default: getStartOfDay
  }
};
var _default2 = processors;
exports.default = _default2;